// **Redux Imports
import { createSlice } from '@reduxjs/toolkit'

const tableFilterInitState = {
  query: '',
  page: 0,
  pageSize: 10
}

export const contestSlice = createSlice({
  name: 'workspace',
  initialState: {
    selectedContest: {},
    contestsTableFilters: { page: 0, pageSize: 10, query: '' },
    // selected contest table filters
    stageTableFilters: { page: 0, pageSize: 10 },
    candidateTableFilters: { ...tableFilterInitState, status: '' },
    scheduleTableFilters: { page: 0, pageSize: 10 },
    pendingEvaluationTableFilters: { page: 0, pageSize: 10 },
    leaderboardTableFilters: {
      ...tableFilterInitState,
      endDate: null,
      startDate: null
    },

    // selected stage table filters
    stageAttemptsTableFilters: { ...tableFilterInitState },
    stageLeaderboardTableFilters: { ...tableFilterInitState },
    stagePendingEvaluationTableFilters: { ...tableFilterInitState }
  },
  reducers: {
    setSelectedContest(state, action) {
      state.selectedContest[action.payload.key] = action.payload.value
    },
    setContestsTableFilters(state, action) {
      state.contestsTableFilters = action.payload
    },
    resetContestsTableFilters(state) {
      state.contestsTableFilters = { page: 0, pageSize: 10 }
    },

    // selected contest table filter actions
    setStageTableFilters(state, action) {
      state.stageTableFilters = action.payload
    },
    resetStageTableFilters(state) {
      state.stageTableFilters = { page: 0, pageSize: 10 }
    },
    setCandidateTableFilters(state, action) {
      state.candidateTableFilters = action.payload
    },
    resetCandidateTableFilters(state) {
      state.candidateTableFilters = { ...tableFilterInitState, status: '' }
    },
    setScheduleTableFilters(state, action) {
      state.scheduleTableFilters = action.payload
    },
    resetScheduleTableFilters(state) {
      state.scheduleTableFilters = { page: 0, pageSize: 10 }
    },
    setManualTableFilters(state, action) {
      state.pendingEvaluationTableFilters = action.payload
    },
    resetManualTableFilters(state) {
      state.pendingEvaluationTableFilters = { page: 0, pageSize: 10 }
    },
    setLeaderboardTableFilters(state, action) {
      state.leaderboardTableFilters = action.payload
    },
    resetLeaderboardTableFilters(state) {
      state.leaderboardTableFilters = {
        ...tableFilterInitState,
        endDate: null,
        startDate: null
      }
    },

    // selected stage filter actions
    setStageAttemptsTableFilters(state, action) {
      state.stageAttemptsTableFilters = action.payload
    },
    resetStageAttemptsTableFilters(state) {
      state.stageAttemptsTableFilters = { ...tableFilterInitState }
    },
    setStageLeaderboardTableFilters(state, action) {
      state.stageLeaderboardTableFilters = action.payload
    },
    resetStageLeaderboardTableFilters(state) {
      state.stageLeaderboardTableFilters = { ...tableFilterInitState }
    },
    setStagePendingEvaluationTableFilters(state, action) {
      state.stagePendingEvaluationTableFilters = action.payload
    },
    resetStagePendingEvaluationTableFilters(state) {
      state.stagePendingEvaluationTableFilters = { ...tableFilterInitState }
    }
  }
})

export const {
  setSelectedContest,
  setContestsTableFilters,
  resetContestsTableFilters,

  // selected contests filter exports
  setStageTableFilters,
  resetStageTableFilters,
  setCandidateTableFilters,
  resetCandidateTableFilters,
  setScheduleTableFilters,
  resetScheduleTableFilters,
  setManualTableFilters,
  resetManualTableFilters,
  setLeaderboardTableFilters,
  resetLeaderboardTableFilters,

  // selected stage filter exports
  setStageAttemptsTableFilters,
  resetStageAttemptsTableFilters,
  setStageLeaderboardTableFilters,
  resetStageLeaderboardTableFilters,
  setStagePendingEvaluationTableFilters,
  resetStagePendingEvaluationTableFilters
} = contestSlice.actions

export default contestSlice.reducer
